// @owners { team: patients }
import { Buffer } from 'buffer';
import { createMMKV } from 'react-native-mmkv';
import { MMKV_STORAGE_ENCRYPTION_KEY } from '~shared/config';
import { getPlatformOS } from '~shared/helpers/getPlatformOS';

const encryptionKey = MMKV_STORAGE_ENCRYPTION_KEY
  ? Buffer.from(MMKV_STORAGE_ENCRYPTION_KEY, 'base64').toString('binary')
  : undefined;

export const Storage = createMMKV(
  getPlatformOS() === 'web' ? { id: 'alto-storage' } : { id: 'alto-storage', encryptionKey },
);
